class UserHeaderController {
    /*@ngInject*/
    constructor($scope, $state, $rootScope, $uibModalStack, companyService, webSocketsService, alertsAndNotificationsService, authService, userService, StorageService, MESSAGECONSTANTS, stateManagementStorageService, uibModalService, jobService) {
        this.$scope = $scope;
        this.$state = $state;
        this.$rootScope = $rootScope;
        this.$uibModalStack = $uibModalStack;
        this.companyService = companyService;
        this.webSocketsService = webSocketsService;
        this.alertsAndNotificationsService = alertsAndNotificationsService;
        this.authService = authService;
        this.userService = userService;
        this.StorageService = StorageService;
        this.MESSAGECONSTANTS = MESSAGECONSTANTS;
        this.stateManagementStorageService = stateManagementStorageService;
        this.uibModalService = uibModalService;
        this.jobService = jobService;
    }
    $onInit() {
        this.$rootScope.showNotificationsIcon = true;
        this.$rootScope.loggingOutInProgress = false;
        this.$scope.userDetails = angular.copy(this.StorageService.get('userDetails'));
        this.searchObject = {};
        this.searchObject.page = 1;
        this.searchObject.size = 20;
        this.searchObject.companyId = this.$rootScope.userDetails.company.companyId;
        this.searchObject.notifyOn = 'GLOBAL';
        this.userNotificationControls = {};
        this.userNotificationControls.setNewNotificationsAsViewed = null;
        this.userNotificationControls.notificationClickCount = 0;
        this.isNotificationClicked = false;
        this.numberOfNewNotifications = 0;
        this.$rootScope.loggingOutFromScreenHavingSaveOption = false;
        this.imageUrl = this.$rootScope.imageUrl;
        if (this.$rootScope.userDetails) {
            this.companyService.getCompanyDetails(this.$rootScope.userDetails.company.companyId, (data) => {
                this.$rootScope.userDetails.company.companyState = data.companyState;
                this.companyService.setCompanyStateLabel();
            }, (error) => {
                //do nothing;
            });
        }
        /**
         * user when clicked on logout from any of
         * the page, This function will be invoked
         */
        this.$rootScope.$watch('userDetails', () => {
            this.$scope.userDetails = angular.copy(this.$rootScope.userDetails);
            //console.log('this.$scope.userDetails : '+ angular.toJson(this.$scope.userDetails));
        }, true);
        this.$rootScope.$on("CallLogoutMethod", (event, data) => {
            this.logout(data);
        });
        $(window).smartresize(() => {
            if ($(document).width() < 991) {
                $('#nav-col').removeClass('open-sidenav');
                $('#nav-col').addClass('close-sidenav');
            }
            else {
                $('#nav-col').removeClass('close-sidenav');
                $('#nav-col').addClass('open-sidenav');
            }
        });
        this.checkIfListScopeErrorExists();
        this.getSalaryDurationOptions();
        this.getAllPreferredJobTypes();
    }
    checkIfListScopeErrorExists() {
        this.userService.getLoggedInUserDetails((data) => {
            let clientLabel = this.$rootScope.userDetails.company.companyType == "Corporation" ? "BU" : "Client";
            /*
                these two variables are returned as true when
                The user had his/her scope definition as ‘list’ for client/bu AND ( if the parent company/corp had created some child clients/bus AND no client/bu was assigned to the user as part of scope definition ).
             */
            if (data.isBUOrClientListEmptyForUser && data.isBUsOrClientsAvailable) {
                this.alertsAndNotificationsService.showBannerMessage("You have a " + clientLabel + " Scope of 'List' but no '" + clientLabel + "' is assigned to you.", "danger");
            }
        }, (error) => {
            this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    }
    destroyModal() {
        this.$rootScope.switchCompanyRepeat = 0;
        this.$rootScope.switchClicked = false;
        let loadingModal = $('#myModal');
        loadingModal.modal("hide");
        $('body').removeClass('modal-open');
        $('.modal-backdrop').remove();
    }
    isStateWithData() {
        let currentState = angular.copy(this.$state.current.name);
        let currentStateSatisfies = (currentState === 'missioncontrol.usermanagement') ||
            (currentState === 'missioncontrol.companymanagement') ||
            (currentState === 'missioncontrol.clientorbu') ||
            (currentState === 'missioncontrol.uploadreq') ||
            (currentState === 'missioncontrol.roleentityscope') ||
            (currentState === 'missioncontrol.settings') ||
            (currentState === 'missioncontrol.notificationpreference') ||
            (currentState === 'missioncontrol.editSharedReq');
        return currentStateSatisfies;
    }
    switchCompany() {
        if (this.isStateWithData()) {
            this.$rootScope.switchClicked = true;
            this.$state.go('missioncontrol.dashboard', null, { reload: true });
        }
        else {
            this.$rootScope.switchClicked = false;
            // this.companyService.showAllCompanies();
            this.uibModalService.showAllCompanies();
        }
    }
    toggleSideNav() {
        $('#nav-col').toggleClass('close-sidenav');
    }
    showUserProfile(user) {
        console.log('in showUserProfile before api : ' + angular.toJson(user));
        this.$state.go('missioncontrol.usermanagement', { userId: user.id, accessMode: this.MESSAGECONSTANTS.ACCESS_MODES.EDIT, manager: null, purpose: 'view userprofile' }, { reload: false });
    }
    logout(data) {
        this.$rootScope.logoutInProgress = true;
        if (this.$rootScope.logoutDialog == undefined) {
            this.$rootScope.logoutInProgress = false;
            this.$rootScope.logoutDialog = bootbox.dialog({
                message: '<span class="loading-message"> Logging Out...<i class="fa fa-spinner fa-spin"></i></span>',
                closeButton: false
            });
        }
        console.log('logout clicked');
        console.log('disconnecting web socket connection');
        // disconnect web sockets
        this.webSocketsService.disconnect();
        this.webSocketsService.disconnectForChime();
        let temp = false;
        if (this.isStateWithData()) {
            if (angular.isDefined(data) && data.logoutnow) {
                temp = true;
            }
            if (temp) {
                let rememberMeStatus = angular.copy(this.StorageService.getCookie('rememberme'));
                let userDetails = angular.copy(this.StorageService.get('userDetails'));
                /**
                 * Api Call for informing Server that
                 * a person want to Logout will happen here
                 */
                this.$rootScope.companyDeletedShowPopup = false;
                this.StorageService.resetBrowserStorage();
                if (angular.isDefined(rememberMeStatus) && (rememberMeStatus !== null) && (rememberMeStatus === true)) {
                    if (angular.isDefined(userDetails) && (userDetails !== null)) {
                        this.StorageService.setCookie('logoutemail', userDetails.emailId);
                    }
                }
            }
        }
        this.$uibModalStack.dismissAll();
        // this.authService.logout((data) => {
        this.StorageService.removeCookie('connect.sid');
        if (_.isNull(this.StorageService.get('companyDetails')) || _.isUndefined(this.StorageService.get('companyDetails'))) {
            this.StorageService.remove('companyDetails');
        }
        this.StorageService.remove('SelectedHostCompany');
        this.StorageService.remove('userDetails');
        if (!this.$rootScope.logoutInProgress || this.authService.currentScreenHasSaveOption(this.$state.current.name)) {
            this.stateManagementStorageService.clear();
            this.$state.go('login', null, { reload: true });
            this.$rootScope.logoutDialog.modal('hide');
        }
        // }, (error) => {
        //     this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        // });
        setTimeout(() => {
            this.$state.reload();
        }, 100);
    }
    showNotifications() {
        this.userNotificationControls.notificationClickCount++;
        this.isNotificationClicked = !this.isNotificationClicked;
    }
    closeDropdown() {
        const dropdown = document.querySelector('.dropdown.open');
        if (dropdown) {
            dropdown.classList.remove('open');
        }
    }
    getSalaryDurationOptions() {
        this.jobService.getSalaryDurationOptions((data) => {
            this.salaryDurationOptions = data;
        }, (error) => {
            this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    }
    getAllPreferredJobTypes() {
        this.jobService.getAllJobTypes((data) => {
            this.jobTypeList = data;
        }, (error) => {
            this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    }
}
UserHeaderController.$inject = ['$scope', '$state', '$rootScope', '$uibModalStack', 'companyService', 'webSocketsService', 'alertsAndNotificationsService', 'authService', 'userService', 'StorageService', 'MESSAGECONSTANTS', 'stateManagementStorageService', 'uibModalService', 'jobService'];
// import * as TEMPLATE from './user-header.html';
import * as TEMPLATE from 'raw-loader!./user-header.html';
export const UserHeaderComponent = {
    selector: 'userHeader',
    component: {
        // templateUrl: 'app/shared/userHeader/user-header.html',
        template: TEMPLATE.default,
        controller: UserHeaderController
    }
};
//# sourceMappingURL=user-header.component.js.map